// import React, { useState } from 'react';

// /**
//  * A reusable checkbox component styled with Tailwind CSS.
//  * 
//  * @param {object} props - The props object.
//  * @param {string} props.label - The label for the checkbox.
//  * @param {boolean} [props.initiallyChecked=false] - Initial checked state of the checkbox.
//  * @param {function} props.onChange - Callback function that fires on state change.
//  * 
//  * @category Components - UI
//  */
// function Checkbox({ initiallyChecked, onChange, name, className }) {
//     const [checked, setChecked] = useState(initiallyChecked);

//     const handleChange = (event) => {
//         setChecked(event.target.checked);
//         if (onChange) {
//             onChange({name: event.target.name, checked: event.target.checked});
//         }
//     };

//     return (
//         <input
//             name={name}
//             type="checkbox"
//             checked={checked}
//             onChange={handleChange}
//             className={`form-checkbox h-5 w-5 text-blue-600 transition duration-200 ease-in-out ${className}`}
//         />
//     );
// }

// export default Checkbox;


import React, { useState } from "react";

/**
 * A reusable checkbox component styled with Tailwind CSS.
 * 
 * @param {object} props - The props object.
 * @param {string} props.label - The label for the checkbox.
 * @param {boolean} [props.checked] - The controlled checked state of the checkbox.
 * @param {boolean} [props.initiallyChecked=false] - Initial checked state of the checkbox (for uncontrolled usage).
 * @param {function} props.onChange - Callback function that fires on state change.
 * 
 * @category Components - UI
 */
function Checkbox({ checked, initiallyChecked = false, onChange, name, className }) {
    // Internal state for uncontrolled usage
    const [internalChecked, setInternalChecked] = useState(initiallyChecked);

    // Handle change event
    const handleChange = (event) => {
        const newChecked = event.target.checked;
        if (onChange) {
            onChange({ name: event.target.name, checked: newChecked });
        }
        if (checked === undefined) {
            setInternalChecked(newChecked); // Update internal state if uncontrolled
        }
    };

    // Determine whether to use controlled or uncontrolled checked state
    const isChecked = checked !== undefined ? checked : internalChecked;

    return (
        <input
            name={name}
            type="checkbox"
            checked={isChecked}
            onChange={handleChange}
            className={`form-checkbox h-5 w-5 text-blue-600 transition duration-200 ease-in-out ${className}`}
        />
    );
}

export default Checkbox;
